import { z } from 'zod';
import { zGoSlice } from '../helpers/fix-go-types';
import { reorderWeeks, thresholdWeeks } from './order-settings';
import { saleStatDays } from './product';

// form validation rules
//
// looseObject, not object: this schema keeps keys it doesn't declare, which is
// how qoh_threshold_percent was retired without a coordinated deploy — see
// below. Every other schema in this family is strict.
export const OrderOptionsSchema = z.looseObject({
  qoh_threshold_weeks: z.literal(thresholdWeeks),
  reorder_weeks: z.literal(reorderWeeks),

  // Go tags these `[]string` with no omitempty, so a nil slice reaches us as
  // null rather than an absent key.
  send_methods: zGoSlice(z.string()),
  emails: zGoSlice(z.email()),

  // qoh_threshold_percent is gone from the API as of ORD-391. Undeclaring it
  // here one release ahead of that removal is what made the removal safe: a
  // browser still on a bundle that required it would have failed validation on
  // every order response. Staying loose rather than strict covered the other
  // direction for the same window — the old bundle went on echoing the value
  // back on PUT, which kept Go's validate:"required" satisfied until the field
  // left the model.
  //
  // Both windows are closed. The schema stays loose so an order cached from
  // before the removal still parses byte-for-byte; tightening to z.object()
  // would now only strip a key nothing writes and nothing reads.
  //
  // sales_period_days is no longer read in the browser — the server computes
  // suggestions — but it is still sent on every order and echoed back on PUT,
  // so it stays declared.
  sales_period_days: z.literal(saleStatDays),
});

export type OrderOptions = z.infer<typeof OrderOptionsSchema>;
